'use client';

import { usePageAction } from '@ria-client/hooks/usePageAction';
import { useNWAElementImpression } from '@ria-client/segment/hooks/useNWAElementImpression';

export interface ReadReviewLinkProps {
  reviewLink: string;
}

const LINK_COPY = 'Read full review';

export function ReadReviewLink({ reviewLink }: ReadReviewLinkProps) {
  const { ref, impressionId, ensureViewed } = useNWAElementImpression({
    component: 'read_full_review_clicked',
    destinationUrl: reviewLink,
    linkCopy: LINK_COPY,
    sectionName: 'product_cards_section',
  });
  const firePageAction = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'read_full_review_clicked',
    actionSection: 'product_cards_section',
    actionType: 'select',
    linkCopy: LINK_COPY,
    parentEventId: impressionId,
  });
  const handleClick = () => {
    ensureViewed();
    firePageAction();
  };

  return (
    <a
      className="typography-text font-medium text-[var(--content-green-dark)]"
      href={reviewLink}
      ref={ref}
      onClick={handleClick}
    >
      {LINK_COPY}
    </a>
  );
}
